export default class Newsletter {
  constructor(theme) {
    this.theme = theme;

    // Use AJAX for submitting the contact form
    this.forms = document.querySelector('.contact-form');

    if (!this.forms) return;

    this.forms.addEventListener('submit', this.onSubmit);

    const success = document.querySelector('.contact-form .form-success');
    const errors = document.querySelector('.contact-form .errors');

    if (errors && errors.length > 0 && errors[0].children.length > 0) {
      this.showAlert(errors[0]);
    } else if (success.length > 0) {
      this.showAlert(success[0]);
    }
  }

    onSubmit = (event) => {
      event.preventDefault();
      var self = this;

      const form = event.target;
      const formData = new FormData(form);
      const formSpinner = form.querySelector('.newsletter-spinner');
      const inputWrapper = form.querySelector('#newsletter-wrapper, [id^="newsletter-wrapper"]');
      const successMsg = form.querySelector('.form-success');

      formSpinner.classList.remove('hide');
      if (inputWrapper) inputWrapper.classList.add('hide');

      fetch('/contact', { method: 'post', body: formData })
        .then(response => {
          if(typeof response.url === 'string' && response.url.includes('/challenge')) {
            form.removeEventListener('submit', self.onSubmit);
            form.submit();
            return false;
          }
          else {
            return response;
          }
        })
        .then(data => {
          if(data !== false) {
            formSpinner.classList.add('hide');
            if (successMsg) successMsg.classList.remove('hide');
          }
        });
    }

    showAlert = (content) => {
      const pageAlert = document.createElement('div');
      pageAlert.classList.add('page-alert', 'page-alert--hidden');
      pageAlert.append(content.cloneNode(true));
      document.body.append(pageAlert);

      const getPageAlert = document.querySelector('.page-alert');
      document.querySelectorAll('.success-msg').forEach(el => el.classList.remove('hidden'));

      setTimeout(() => {
        getPageAlert.classList.remove('page-alert--hidden');
      }, 1000);

      setTimeout(() => {
        getPageAlert.classList.add('page-alert--hidden');
      }, 8000);
    }
}
